import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {Wrapper, Title, Refresh} from './Error.style';

class Error extends PureComponent {
  render() {
    const {callback, message} = this.props;
    return (
      <Wrapper>
        <Title><FormattedMessage id={message} /></Title>
        <Refresh onClick={callback}>Ok</Refresh>
      </Wrapper>
    );
  }
}

Error.propTypes = {
  callback: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired
};

export default Error;



// WEBPACK FOOTER //
// ./components/Error/Error.js